import z from "zod";
import RemoteCollection from "../../utility/remote-collection";

export const NewsRPMParserFeedListItemSchema = z.object({
  id: z.number(),
  feedType: z.string().default("Unknown Feed Type"),
  providerCode: z.string().nullish(),
  provider: z.string().default("Unknown Provider"),
  uri: z.string().nullish(),
  lastSuccessfulRetrieval: z.string().nullish(),
  lastError: z.string().nullish(),
});

export const NewsRPMParserFeedDetailItemSchema = NewsRPMParserFeedListItemSchema.extend({
  bodySource: z.string().nullish(),
  feedHandler: z.string().nullish(),
  originator: z.string().nullish(),
  legacyChannelId: z.number().nullish(),
  feedOptions: z.unknown().nullish(),
  retrieveEvery: z.number().nullish(),

  lastRetrieval: z.string().nullish(),
  nextRetrieval: z.string().nullish(),
  lastLog: z.string().nullish(),

}).loose();

export type NewsRPMParserFeedListItem = z.output<typeof NewsRPMParserFeedListItemSchema>;
export type NewsRPMParserFeedDetailItem = z.output<typeof NewsRPMParserFeedDetailItemSchema>;

export const feedCollection = new RemoteCollection("/api/newsrpm/parser/admin/feed", NewsRPMParserFeedListItemSchema, NewsRPMParserFeedDetailItemSchema);
export const NewsRPMParserJournalListItemSchema = z.object({
  id: z.number(),
  createdAt: z.string(),
  headline: z.string().nullish(),
  provider: z.string().nullish(),
  __idx: z.number().exactOptional(),
});
export const NewsRPMParserJournalDetailItemSchema = NewsRPMParserJournalListItemSchema.extend({
  date: z.string().nullish(),
  uri: z.string().nullish(),
  sourceId: z.string().nullish(),
  slug: z.string().nullish(),
  error: z.string().nullish(),
  errorCount: z.number().nullish(),
  parserData: z.unknown().nullish(),
  version: z.number().nullish(),
  updatedAt: z.string().nullish(),
}).loose();
export type NewsRPMParserJournalListItem = z.output<typeof NewsRPMParserJournalListItemSchema>;
export type NewsRPMParserJournalDetailItem = z.output<typeof NewsRPMParserJournalDetailItemSchema>;
export const journalCollection = new RemoteCollection(
  "/api/newsrpm/parser/admin/journal",
  NewsRPMParserJournalListItemSchema,
  NewsRPMParserJournalDetailItemSchema,
);